import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/Service/api.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { ExportService } from 'src/app/Service/export.service';
import { CookieService } from 'ngx-cookie-service';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import * as XLSX from 'xlsx';



@Component({
  selector: 'app-evaluation-report',
  templateUrl: './evaluation-report.component.html',
  styleUrls: ['./evaluation-report.component.css']
})
export class EvaluationReportComponent implements OnInit {
  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe, public cookie: CookieService, private _exportService: ExportService) {
}


  formTitle = "Employee Daily Worklog";
  loadprojectexcel: boolean = false;

  ngOnInit(): void {
    this.loadAllAssignee();
    // this.loadAllRoles();
    this.loadAllProjects(this.str);
    this.loadAllUsers(this.str);
    this.getMonthAndYear();
    this.findTotalDays(this.year, this.month);




  }

  dt = new Date();
  month: number;
  year: number;
  START_DATE: string;
  END_DATE: string;
  radioValue = "E";

  getMonthAndYear() {
    this.month = this.dt.getMonth();
    this.year = this.dt.getFullYear();
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["PROJECT", "Project"], ["MODULE", "Module"], ["FEATURE", "Feature"], ["TASK", "Task"], ["SUBTASK", "Subtask"]];
  filterQuery: string = "";
  isProjectSpinning = false;
  loadingRecords = false;
  projectData = [];
  projectDataForExcel = [];
  date = new Date();
  projectColumns: string[] = [];
  projectNames: string[] = [];
  projectKeys: string[] = []; // To store the original project keys without transformations



  calculateTotals() {
    const totals = {
      EMP_NAME: 'Total',
      TOTAL_TIME: '00:00:00',
    };
    
    // Initialize totals for each project
    this.projectKeys.forEach(key => {
      totals[key] = '00:00:00';
    });

    // Calculate total time for each project
    this.projectData.forEach(employee => {
      this.projectKeys.forEach(key => {
        totals[key] = this.addTime(totals[key], employee[key]);
      });
      totals.TOTAL_TIME = this.addTime(totals.TOTAL_TIME, employee.TOTAL_TIME);
    });

    // Add the totals row to the project data
    this.projectData.push(totals);
  }

  addTime(time1: string, time2: string): string {
    const time1Parts = time1.split(':').map(Number);
    const time2Parts = time2.split(':').map(Number);

    let hours = time1Parts[0] + time2Parts[0];
    let minutes = time1Parts[1] + time2Parts[1];
    let seconds = time1Parts[2] + time2Parts[2];

    if (seconds >= 60) {
      minutes += Math.floor(seconds / 60);
      seconds = seconds % 60;
    }
    if (minutes >= 60) {
      hours += Math.floor(minutes / 60);
      minutes = minutes % 60;
    }

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }



  getUserWiseSummary(reset: boolean = false) {
    var ok = true;
    if (this.MODULE_ASSIGNEE_ID.length == 0) {
      ok = false
    }

    if (ok) {
      if (reset) {
        this.pageIndex = 1;
      }

      this.loadingRecords = true;
      var sort: string;
      try {
        sort = this.sortValue.startsWith("a") ? "asc" : "desc";

      } catch (error) {
        sort = "";
      }



      if (this.searchText != "") {
        var likeQuery = " AND";
        this.columns.forEach(column => {
          likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
        });
        likeQuery = likeQuery.substring(0, likeQuery.length - 2)

      }

      this.applyFilter();

      var filter = ""
      if (likeQuery)
        filter = this.filterQuery + likeQuery;
      else
        filter = this.filterQuery;

      // this._apiService.getEvaluation(
      //   this.userID.toString(),
      //   this.projectID.toString(),
      //   this.START_DATE,
      //   this.END_DATE).subscribe(data => {

      //     if (data['code'] === 200) {
      //       this.loadingRecords = false;
      //       this.isProjectSpinning = false;
      //       this.totalRecords = data['count'];
      //       this.projectData = data['results'];

      //       if (this.projectData && this.projectData.length > 0) {
      //         const sampleEmployee = this.projectData[0];
      //         this.projectKeys = Object.keys(sampleEmployee)
      //           .filter(key => key !== 'EMPLOYEE_ID' && key !== 'EMP_NAME' && key !== 'TOTAL_TIME' && key !== 'DATE');

      //         this.projectNames = this.projectKeys.map(project => project.replace(/_/g, ' ')); // Replace underscores with spaces
      //       }
      //     }
      //   });


      this._apiService.getEvaluation(
        this.userID.toString(),
        this.projectID.toString(),
        this.START_DATE,
        this.END_DATE
      ).subscribe(data => {
        if (data['code'] === 200) {
          this.loadingRecords = false;
          this.isProjectSpinning = false;
          this.totalRecords = data['count'];
          this.projectData = data['results'];

          if (this.projectData && this.projectData.length > 0) {
            const sampleEmployee = this.projectData[0];
            this.projectKeys = Object.keys(sampleEmployee)
              .filter(key => key !== 'EMPLOYEE_ID' && key !== 'EMP_NAME' && key !== 'TOTAL_TIME' && key !== 'DATE');

            this.projectNames = this.projectKeys.map(project => project.replace(/_/g, ' ')); // Replace underscores with spaces

            // Calculate the totals
            this.calculateTotals();
          }
        }
      });
    }
  }

  filterClass: string = "filter-invisible";
  isFilterApplied: string = "default";
  PROJECT_DATE = null;

  applyFilter() {
    this.getMonthAndYear();
    this.getDaysOfMonth(this.month, this.year);

    this.isFilterApplied = "primary";
    this.filterClass = "filter-invisible";
  }

  showFilter(): void {
    if (this.filterClass === "filter-visible")
      this.filterClass = "filter-invisible";
    else
      this.filterClass = "filter-visible";
  }

  clearFilter() {
    this.filterQuery = "";

    this.isFilterApplied = "default";
    this.filterClass = "filter-invisible";

    this.dt = new Date();
    this.date = this.dt;

    this.projectID = [];
    this.userID = [];
    this.TYPE = "";
    this.str = "";

    this.loadAllProjects(this.str);
    this.loadAllUsers(this.str)

    this.getMonthAndYear();
    this.findTotalDays(this.year, this.month);
    this.loadAllAssignee();
    // this.loadAllRoles();
    this.getUserWiseSummary(true);
    this.radioValue = "E";
  }

  sortKey: string = "WORKED_DATETIME";

  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'WORKED_DATETIME';
    const sortOrder = (currentSort && currentSort.value) || 'desc';
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;

    if (this.MODULE_ASSIGNEE_ID.length != 0) {
      this.getUserWiseSummary();
    }
  }

  days = new Array();

  getDaysOfMonth(MM, yyyy) {
    this.days = [];

    this.START_DATE = this.datePipe.transform(this.START_DATE, 'yyyy-MM-dd');
    var d = new Date(this.START_DATE).getDate();


    this.END_DATE = this.datePipe.transform(this.END_DATE, 'yyyy-MM-dd');
    var e = new Date(this.END_DATE).getDate();


    for (var i = d; i <= e; i++) {
      var date = new Date(yyyy, MM, i);
      if (date != null) {
        this.days.push(this.datePipe.transform(date, 'yyyy-MM-dd'));
      }
    }
  }

  findTotalDays(yyyy, MM) {
    var numOfDays = new Date(yyyy, MM + 1, 0).getDate();

    var d = new Date(yyyy, MM, 1);
    this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

    var e = new Date(yyyy, MM, numOfDays);
    this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');

    for (var i = 0; i < numOfDays; i++) {
      var date = new Date(yyyy, MM, i + 1);
      if (date != null) {
        this.days[i] = this.datePipe.transform(date, 'yyyy-MM-dd');
      }
    }
  }

  onEnterGetUserWiseSummary() {
    document.getElementById('button1').focus();
    this.getUserWiseSummary(true);
  }


  // fireEvent() {
  //   // Prepare the header row for the table columns
  //   const headerRow = [
  //     'Employee Name',
  //     'Total Hours',
  //     ...this.projectNames // Adding dynamic project names columns
  //   ];

  //   // Prepare the data rows
  //   const employeeRows = this.projectData.map((employee) => {
  //     const row = [
  //       employee.EMP_NAME, // Employee name
  //       employee.TOTAL_TIME, // Total time
  //       ...this.projectKeys.map((key) => employee[key] || '0'), // Get the values for each project
  //     ];
  //     return row;
  //   });

  //   // Combine headers and data into one array for Excel export
  //   const worksheetData = [headerRow, ...employeeRows];

  //   // Create a worksheet from the data
  //   const ws = XLSX.utils.aoa_to_sheet(worksheetData);

  //   // Define column widths for better readability
  //   ws['!cols'] = [
  //     { wch: 20 }, // Employee Name
  //     { wch: 15 }, // Total Hours
  //     ...this.projectNames.map(() => ({ wch: 20 })) // Adjust width for each project column
  //   ];

  //   // Create a new workbook and append the worksheet
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, 'Employee Data');

  //   // Save the workbook as an Excel file
  //   XLSX.writeFile(wb, 'Employee Daily Worklog.xlsx');
  // }


  fireEvent() {
    // Prepare the header row for the table columns
    const headerRow = [
      'Employee Name',
      'Total Hours',
      ...this.projectNames.map((project) => 
        project.length > 5 ? project.slice(0, 20) + '...' : project // Truncated project names
      ),
    ];
  
    // Prepare the data rows
    const employeeRows = this.projectData.map((employee) => {
      const row = [
        employee.EMP_NAME, // Employee name
        employee.TOTAL_TIME, // Total time
        ...this.projectKeys.map((key) => employee[key] || '0'), // Get the values for each project
      ];
      return row;
    });
  
    // Add a bolded "Total" row once
    // const totalRow = ['Total', '', ...this.projectKeys.map((key) => this.calculateTotal(key))];
    
    // Combine headers, data, and the total row into one array for Excel export
    const worksheetData = [headerRow, ...employeeRows,];
  
    // Create a worksheet from the data
    const ws = XLSX.utils.aoa_to_sheet(worksheetData);
  
    // Define column widths for better readability
    ws['!cols'] = [
      { wch: 20 }, // Employee Name
      { wch: 15 }, // Total Hours
      ...this.projectNames.map(() => ({ wch: 20 })), // Adjust width for each project column
    ];
  
    // Apply bold style to the "Total" row
    const totalRowIndex = worksheetData.length - 1; // Last row index
    for (let col = 0; col < worksheetData[totalRowIndex].length; col++) {
      const cellAddress = XLSX.utils.encode_cell({ r: totalRowIndex, c: col });
      if (!ws[cellAddress]) continue;
      ws[cellAddress].s = { font: { bold: true } }; // Make the text bold
    }
  
    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Employee Data');
  
    // Save the workbook as an Excel file
    XLSX.writeFile(wb, 'Employee Daily Worklog.xlsx');
  }
  
  // Helper function to calculate totals for a specific project key
  calculateTotal(key: string): string {
    return this.projectData
      .reduce((sum, employee) => sum + (parseFloat(employee[key]) || 0), 0)
      .toFixed(2); // Format total as a number with two decimal places
  }
  

  // Getting Users
  assigneeList = [];
  categoryID = 0;

  loadAllAssignee() {
    this.assigneeList = [];
    var USER_ID = this._apiService.userId;

    this._apiService.getAllUsers(0, 0, 'ID', 'desc', ' AND IS_ACTIVE=1').subscribe(userData => {
      if (userData['code'] == 200) {
        this.assigneeList = userData['data'];
        var userCategory = this.assigneeList.filter(x => x.ID == this._apiService.userId);
        if (userCategory != null && userCategory != undefined) {
          this.categoryID = userCategory[0]['TASK_CATEGORY_ID'];
        } else {
          this.categoryID = 0;
        }
        this.loadAllRoles();
      }
    }, err => {
    });
  }

  roleData = [];

  loadAllRoles() {
    this.roleData = [];

    var level = this.cookie.get("level");
    var nextLevel = Number(this.cookie.get("level")) + 1;

    // level = level + ',' + nextLevel;

    if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2") {
      this._apiService.getAllRoles(0, 0, 'ID', 'desc', '').subscribe(data => {
        if (data['code'] == 200) {
          this.roleData = data['data'];

          this.findNewAssigneeList();


          if (this.MODULE_ASSIGNEE_ID.length != 0) {
            this.getUserWiseSummary(true);
          }
        }

      }, err => {

      });

    } else {
      this._apiService.getAllRoles(0, 0, 'ID', 'desc', ' and LEVEL >= (' + level + ')').subscribe(data => {
        if (data['code'] == 200) {


          this.roleData = data['data'];

          this.findNewAssigneeList();


          if (this.MODULE_ASSIGNEE_ID.length != 0) {
            this.getUserWiseSummary(true);
          }
        }

      }, err => {

      });
    }
  }

  newAssigneeList = [];
  MODULE_ASSIGNEE_ID = [];
  TYPE = "";

  findNewAssigneeList() {
    this.newAssigneeList = [];
    this.MODULE_ASSIGNEE_ID = [];

    for (var j = 0; j < this.roleData.length; j++) {
      for (var k = 0; k < this.assigneeList.length; k++) {
        if (Number(this.assigneeList[k]['ROLE_IDS']) == this.roleData[j]['ID']) {
          if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2" || this.cookie.get("level") == "3") {
            this.newAssigneeList.push(this.assigneeList[k]);

          } else if (this.cookie.get("level") == "4") {
            if (Number(this.assigneeList[k]['TASK_CATEGORY_ID']) == this.categoryID) {
              this.newAssigneeList.push(this.assigneeList[k]);
            }

          } else {
            if (Number(this.assigneeList[k]['ID']) == this._apiService.userId) {
              this.newAssigneeList.push(this.assigneeList[k]);
            }
          }
        }
      }
    }
    for (var i = 0; i < this.newAssigneeList.length; i++) {
      this.MODULE_ASSIGNEE_ID.push(this.newAssigneeList[i]['ID']);
    }
  }

  projectID = [];
  projectList = [];

  loadAllProjects(str) {
    this._apiService.getAllProjects(0, 0, 'START_DATE', 'desc', str).subscribe(project => {
      if (project['code'] == 200) {
        this.projectList = project['data'];

        for (var i = 0; i < this.projectList.length; i++) {
          this.projectID.push(this.projectList[i]['ID']);
        }
      }

    }, err => {

    });
  }



  userID = [];
  userList = [];

  loadAllUsers(str) {
    this._apiService.getusers(0, 0, '', '', str).subscribe(usertData => {
      if (usertData['code'] == 200) {
        this.userList = usertData['data'];
        for (var i = 0; i < this.userList.length; i++) {
          this.userID.push(this.userList[i]['ID']);
        }
      }

    }, err => {

    });
  }



  str = "";

  onStatusChange(type) {

    this.projectID = [];
    this.userID = [];

    if (type == "B") {
      this.str = ' and IS_ACTIVE=1 and IS_BILLABLE=1';

    } else if (type == "NB") {
      this.str = ' and IS_ACTIVE=1 and IS_BILLABLE=0';

    } else if (type == null) {
      this.str = ' and IS_ACTIVE=1 and IS_BILLABLE in (0,1)';
    }

    this.loadAllProjects(this.str);
    this.loadAllUsers(this.str)
  }

  @ViewChild('endDatePicker') endDatePicker: NzDatePickerComponent;

  startDateHandle(open: boolean) {
    this.END_DATE = null;

    if (!open) {
      this.endDatePicker.open();
      this.END_DATE = this.START_DATE;
    }
  }

  disabledEndDate = (endValue: Date): boolean => {
    if (this.START_DATE != null) {
      if (!endValue) {
        return false;
      }

      var previousDate = new Date(this.START_DATE);
      previousDate.setDate(previousDate.getDate() + (-1));

      return endValue <= new Date(previousDate);
    };
  }



  applyWithRadioButtons() {
    this.loadingRecords = true;
    this.pageIndex = 1;

    // this._apiService.getEvaluation(this.pageIndex, this.pageSize, 'WORKED_DATETIME', 'desc', this.searchText, this.MODULE_ASSIGNEE_ID.toString(), this.projectID.toString(), this.START_DATE, this.END_DATE).subscribe(data => {
    this._apiService.getEvaluation(this.userID.toString(), this.projectID.toString(), this.START_DATE, this.END_DATE).subscribe(data => {

      this.loadingRecords = false;


      this.totalRecords = data['count'];
      this.projectData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });
  }


}
